<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2021-09-13</p>
    <div class="content">
      <!-- 第一段内容：活动介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="formatHighlight(currentNews.content?.split('---')[0] || '')"></p>
        </div>
      </div>

      <!-- 第二段内容：嘉宾介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="formatHighlight(currentNews.content?.split('---')[1] || '')"></p>
        </div>
      </div>

      <!-- 图片1：洪智勇参加决赛 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url" :alt="currentNews.other?.picture1?.caption">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第三段内容：获奖信息 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="formatHighlight(currentNews.content?.split('---')[2] || '')"></p>
        </div>
      </div>

      <!-- 图片2：颁奖现场 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url" :alt="currentNews.other?.picture2?.caption">
          <p class="image-caption">{{ currentNews.other?.picture2?.caption }}</p>
        </div>
      </div>

      <!-- 图片3：获奖证书 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url" :alt="currentNews.other?.picture3?.caption">
          <p class="image-caption">{{ currentNews.other?.picture3?.caption }}</p>
        </div>
      </div>

      <!-- 第四段内容：大赛背景 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="formatHighlight(currentNews.content?.split('---')[3] || '')"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'chuangkezhongguo');
  return newsItem || {};
});

// 处理高亮文本
const formatHighlight = (text: string) => {
  if (!text) return '';
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlight">$1</span>');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  text-indent: 2em; /* 首行缩进 */
  line-height: 1.8; /* 行高 */
  margin-bottom: 1em; /* 段落间距 */
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 80%; /* Adjust width as needed */
  height: auto; /* Maintain aspect ratio */
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

// 高亮样式
:deep(.highlight) {
  // background-color: yellow; /* Or use a different highlight style */
  color: #000fe5; /* Example highlight color */
  font-weight: bold;
}
</style> 